export interface EnvConfig {
  environment: string;
  url: string;
  apiUrl: string;
  netboxUrl: string;
  azureAuth: {
    auth: {
      authority: string;
      clientId: string;
      redirectUri: string;
    };
    cache: {
      cacheLocation: string;
      storeAuthStateInCookie: boolean;
    };
  };
  sentryDSN: string;
  googleAnalyticsTracker: string;
  googleMapsKey: string;
  trackUserActivity: boolean;
  appVersion: string;
}

export function getEnvConfig(): EnvConfig {
  return {
    environment: import.meta.env.VITE_ENVIRONMENT,

    // URLs.
    url: import.meta.env.VITE_URL,
    apiUrl: import.meta.env.VITE_API_URL,
    netboxUrl: import.meta.env.VITE_NETBOX_URL,

    // Azure auth.
    azureAuth: {
      auth: {
        authority: "https://login.microsoftonline.com/common",
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
        redirectUri: `${import.meta.env.VITE_URL}auth-callback`,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
      },
    },

    // Sentry.
    sentryDSN: import.meta.env.VITE_SENTRY_DSN,

    // Google.
    googleAnalyticsTracker: import.meta.env.VITE_GOOGLE_ANALYTICS_TRACKER,
    googleMapsKey: import.meta.env.VITE_GOOGLE_MAPS_KEY,

    // Other.
    trackUserActivity: import.meta.env.VITE_TRACK_USER_ACTIVITY === "on",

    appVersion: import.meta.env.VITE_VERSION,
  };
}
